@if (ruleGroup) {
  <shared-rule-group [ruleGroup]="ruleGroup" [searchableProperties]='searchableProperties'
  (edit)="updateRuleGroup($event)"></shared-rule-group>
  <div class="d-flex justify-content-center">
    @if (ruleGroup.ruleObjects.length == 0) {
      <a (click)="addRule()" class="btn btn-sm btn-primary" style="width:25%">+
      Add Rule</a>
    }
  </div>
}